// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__S7d4U","white":"badge_white__7IUDv","text":"badge_text__ETHyX"};